const FinancialPanel = ({ totalInvested, formatPrice, userApps }) => {

  const stats = [
    {
      title: 'Total Investido',
      value: formatPrice(totalInvested),
      bgColor: 'bg-blue-50 dark:bg-blue-900/20',
      textColor: 'text-blue-900 dark:text-blue-200',
      accentColor: 'text-blue-800 dark:text-blue-300',
      iconBgColor: 'bg-blue-100 dark:bg-gray-700 dark:text-white',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: 'Total de Apps',
      value: userApps.length,
      bgColor: 'bg-green-50 dark:bg-green-900/20',
      textColor: 'text-green-900 dark:text-green-200',
      accentColor: 'text-green-800 dark:text-green-300',
      iconBgColor: 'bg-green-100 dark:bg-gray-700 dark:text-white',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      )
    }
  ];

  return (
    <div className="bg-white border-gray-100 dark:bg-gray-800 dark:border-gray-700 p-6 rounded-none shadow-sm border hover:shadow-md transition-shadow duration-300">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-white">Resumo Financeiro</h3>
        <div className="w-10 h-10 bg-gradient-to-r from-blue-100 to-green-100 dark:bg-gray-700 dark:bg-none rounded-none flex items-center justify-center">
          <svg className="w-5 h-5 text-gray-600 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {stats.map((stat, index) => (
          <div
            key={index}
            className={`${stat.bgColor} border-opacity-20 dark:border-gray-600 p-5 rounded-none border transition-transform duration-200 hover:scale-[1.02]`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className={`text-sm font-medium ${stat.accentColor}`}>
                {stat.title}
              </span>
              <div className={`p-2 rounded-none ${stat.iconBgColor}`}>
                {stat.icon}
              </div>
            </div>
            
            <p className={`text-2xl font-bold ${stat.textColor}`}>
              {stat.value}
            </p>
            
            <div className="mt-3 pt-3 border-t border-current border-opacity-20 dark:border-gray-600">
              <span className={`text-xs ${stat.accentColor} opacity-70 dark:opacity-90`}>
                {index === 0 ? 'Valor total investido' : 'Aplicativos cadastrados'}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Adicional: Progress bar ou informação extra */}
      {userApps.length > 0 && (
        <div className="mt-6 pt-4 border-gray-100 dark:border-gray-700 border-t">
          <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-300">
            <span>Média por app</span>
            <span className="font-medium text-gray-800 dark:text-white">
              {formatPrice(totalInvested / userApps.length)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinancialPanel;